module.exports = __webpack_public_path__ + "static/media/KTR700.06612241.jpg";